import { AiOutlineExclamationCircle } from 'react-icons/ai';
import Footer from '../components/layout/footer';
import Navbar from '../components/layout/navbar';

const ErrorPage: React.FC = () => {
  const message = 'Something went wrong while registering.';
  return (
    <div className="bg-[#E6E9EB]">
      <Navbar />
      <div className="h-[70vh]">
        <div className="w-full h-full mx-auto text-center flex flex-col justify-center items-center min-h-[65vh]">
          <span>
            <AiOutlineExclamationCircle size={96} color="red" />
          </span>
          <p className="text-3xl">{message}</p>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ErrorPage;
